import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchCustomer, getCustomer } from '@client/redux/modules/customer';

export const useCustomer = () => {
    const dispatch = useDispatch();
    const customer = useSelector(getCustomer);

    useEffect(() => {
        dispatch(fetchCustomer());
    }, [dispatch]);

    return customer;
};
